"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const FlightDownSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3332_52176)">
      <path d="M11.2651 2.89914L11.2651 1.59318L8.00014 2.89914L4.7343 1.59318L4.7343 2.89914L6.69371 4.20557L6.69371 7.26545L1.46892 5.37484L1.46892 6.61154L6.69325 10.7368L6.69371 13.3492C6.69069 13.5226 6.72225 13.6949 6.78652 13.856C6.8508 14.017 6.94652 14.1637 7.06809 14.2874C7.18966 14.4111 7.33464 14.5094 7.49459 14.5764C7.65454 14.6435 7.82624 14.678 7.99968 14.678C8.17311 14.678 8.34481 14.6435 8.50476 14.5764C8.66471 14.5094 8.80969 14.4111 8.93126 14.2874C9.05283 14.1637 9.14855 14.017 9.21283 13.856C9.2771 13.6949 9.30866 13.5226 9.30564 13.3492L9.30564 10.668L14.5304 6.5432L14.53 5.37438L9.30518 7.20957L9.30518 4.20511L11.2651 2.89914Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_3332_52176">
        <rect width="1em" height="1em" fill="none" />
      </clipPath>
    </defs>
  </svg>


)

const FlightDownIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={FlightDownSvg} {...props} />
);

export default FlightDownIcon